module.exports = __webpack_public_path__ + "media/npc_dota_hero_huskar.fc679e65.webm";